import type { z } from 'zod';

import { NonEmptyText } from './non-empty-text';

// TODO: Add validation for PlateId
export const PlateId = NonEmptyText;

export type PlateId = z.infer<typeof PlateId>;
